var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeNotiLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.2902 23.9868L4.80078 19.4894L9.31136 4L24.8008 8.49736L20.2902 23.9868ZM7.14205 18.2064L19.0204 21.6587L22.4727 9.78043L10.5944 6.32804L7.14205 18.2064Z",
    fill: "#1E2D66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.1632 12.6377C15.9304 12.6377 16.5257 13.2329 16.5257 14.0001C16.5257 14.7673 15.9304 15.3626 15.1632 15.3626C14.396 15.3626 13.8008 14.7673 13.8008 14.0001C13.814 13.2329 14.4092 12.6377 15.1632 12.6377ZM14.2241 16.3282H16.1024V25.0451H14.2241V16.3282Z",
    fill: "#1E2D66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNotiLogoIcon);
export default __webpack_public_path__ + "static/media/home_noti_logo_icon.4217535f099f16c486b3b5d4178e45d7.svg";
export { ForwardRef as ReactComponent };